import { IconDefinition } from "./types";

const star: IconDefinition = {
  iconName: "star",
  width: 576,
  height: 512,
  svgPathData:
    "M288.2-52.8c5.9 11.7 36.8 72.1 92.6 181.4 121.2 19.3 188.2 29.9 201.1 32-9.2 9.3-57.2 57.3-143.9 144.1 19.1 121.2 29.7 188.2 31.7 201.2-11.7-5.9-72.2-36.7-181.5-92.3-109.3 55.6-169.8 86.4-181.5 92.3 2-12.9 12.6-80 31.7-201.2-86.7-86.8-134.7-134.8-143.9-144.1 12.9-2.1 80-12.7 201.1-32 55.8-109.3 86.6-169.7 92.6-181.4zm0 105.6l-55.4 108.5-5.6 10.9-12.1 1.9-120.3 19.1 86.1 86.2 8.6 8.6-1.9 12.1-19 120.3 108.6-55.2 10.9-5.5 10.9 5.5 108.6 55.2-19-120.3-1.9-12.1 8.6-8.6 86.1-86.2-120.3-19.1-12.1-1.9-5.6-10.9-55.4-108.5z",
  iconType: "fill",
  fontAwesomeName: "star",
  unicode: 0xf005,
};

export { star };
